import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {authSelector} from "../redux/selectors";
import {verify} from "../redux/actions";

class Verify extends Component {
    componentDidMount() {
        if (this.props.match.params.key) {
            this.props.verify(this.props.match.params.key)
        }
        document.title = "Addiction | Email Verification"
    }
    render() {
        if (this.props.isAuthenticated) {
            return (
                <div>
                    <h1>Email Verification</h1>
                    <div className="panel">
                        <div className="panel-adt">
                            {
                                (this.props.auth.currentUser.emailVerified) ?
                                    (
                                        <div>
                                            <h2 className="text-primary">Success!</h2>
                                            <p>Your email is verified.  If you have other tabs open you may need to refresh them.</p>
                                        </div>
                                    )
                                    :
                                    (
                                        <div>
                                            <h2>Verifying...</h2>
                                            <p>Please Wait.</p>
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                </div>
            )
        } else {
            return <Redirect to="/login" />

        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    isAuthenticated: state.auth.loggedIn,
});

const mapDispatchToProps = (dispatch) => ({
    verify: (key) => dispatch(verify(key))
});

export default connect(mapStateToProps, mapDispatchToProps)(Verify);


// WEBPACK FOOTER //
// ./src/Auth/Verify.js